import React from "react";
import { Provider } from "react-redux";
import {
  Route,
  Switch,
  BrowserRouter as Router,
  Redirect
} from "react-router-dom";

import store from "../src/redux/store";
import { MobileShell, MobileContentBox } from "../src/Layout";
import AlgoliaWrapper from "../src/AlgoliaWrapper";
import FilterContainer from "../src/FilterContainer";
import ConnectedArticleView from "../src/ConnectedArticleView";
import CartView from "../src/CartView";
import LoginView from "../src/LoginView";
import ProfileView from "../src/ProfileView";
import Checkout, { CheckoutSuccess } from "../src/Checkout";
import Intro from "../src/Intro";

function AppRouter() {
  return (
    <Router>
      <div className="w-full h-full">
        <AlgoliaWrapper
          appID="KSG2DI6WKR"
          apiKey="4ff172cb1dc0e6b74c0cdc60f92faec1"
          indexName="appArticles"
          render={({
            searchState,
            onResetSearchState,
            clearAutoComplete,
            defaultRefinements,
            refinementAttributes
          }) => (
            <React.Fragment>
              <Switch>
                <Route
                  exact
                  path="/intro"
                  render={() => (
                    <Intro onResetSearchState={onResetSearchState} />
                  )}
                />
                <Route
                  exact
                  path="/filter"
                  render={() => (
                    <FilterContainer
                      searchState={searchState}
                      onResetSearchState={onResetSearchState}
                      clearAutoComplete={clearAutoComplete}
                      defaultRefinements={defaultRefinements}
                      refinementAttributes={refinementAttributes}
                    />
                  )}
                />
                <MobileShell>
                  <MobileContentBox>
                    <Switch>
                      <Route
                        exact
                        path="/"
                        render={() => <Redirect to="/intro" />}
                      />
                      <Route exact path="/cart" render={() => <CartView />} />
                      <Route
                        exact
                        path="/profile"
                        render={() => {
                          const isLoggedIn =
                            store.getState().auth.authStatus.indication ===
                            "loaded";
                          if (isLoggedIn) {
                            return <ProfileView />;
                          }
                          return <LoginView />;
                        }}
                      />
                      <Route
                        exact
                        path="/article"
                        render={() => <ConnectedArticleView />}
                      />
                      <Route
                        exact
                        path="/checkout"
                        render={() => <Checkout />}
                      />
                      <Route
                        exact
                        path="/checkout/success"
                        render={() => <CheckoutSuccess />}
                      />
                    </Switch>
                  </MobileContentBox>
                </MobileShell>
              </Switch>
            </React.Fragment>
          )}
        />
      </div>
    </Router>
  );
}

function App() {
  return (
    <Provider store={store}>
      <AppRouter />
    </Provider>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js